import { MaterialSymbolName } from 'components/atoms/MaterialIcon/names';

interface Tooltip {
  name: MaterialSymbolName;
  color: string;
  text: string;
}

function getTooltip(status: string, errorMessage: string): Tooltip | undefined {
  switch (status) {
    case 'in_ocr':
      return {
        name: 'document_scanner' as MaterialSymbolName,
        color: 'var(--color-brand)',
        text: 'File is being processed by OCR',
      };

    case 'ocr_ready':
      return {
        name: 'pending' as MaterialSymbolName,
        color: 'var(--color-brand)',
        text: 'File is waiting to be processed by OCR',
      };
    case 'review_ready':
      return {
        name: 'visibility' as MaterialSymbolName,
        color: '#5ba55b',
        text: 'File is ready for review',
      };
    case 'in_review':
      return {
        name: 'visibility_lock' as MaterialSymbolName,
        color: 'var(--color-brand)',
        text: 'File is being reviewed',
      };

    case 'failed':
      return {
        name: 'error' as MaterialSymbolName,
        color: 'var(--error-text-color)',
        text: errorMessage,
      };
    case 'ready_for_training':
      return {
        name: 'model_training' as MaterialSymbolName,
        color: 'var(--color-brand)',
        text: 'File is ready for training',
      };
    default:
      return undefined;
  }
}

export { getTooltip };
